import { Component, OnInit, signal, ViewEncapsulation, WritableSignal } from '@angular/core'
import { Router } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { UserService } from 'src/app/service/user-info/user.service'
import { DdcTextGradientComponent } from '../../shared/ddc/ddc-text-gradient/ddc-text-gradient.component'
import { DdcPricingPlanComponent } from '../ddc-pricing-plan/ddc-pricing-plan.component'

@Component({
  selector: 'ddc-pricing',
  templateUrl: './ddc-pricing.component.html',
  styleUrl: './ddc-pricing.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [DdcTextGradientComponent, AngularMaterialsModules, DdcPricingPlanComponent],
})
export class DdcPricingComponent implements OnInit {
  _currentUserInfo: WritableSignal<any> = signal(null)
  // In your component
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.userService.userInfo$.subscribe(userInfo => {
      this._currentUserInfo.set(userInfo)
    })
  }

  toBillingPage = (subscriptionType: string): void => {
    this.router.navigate(['/billing'], { queryParams: { type: subscriptionType } })
  }
}
